import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { CartProvider } from "./contexts/CartContext";

// Components
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AdminLayout } from "./components/AdminLayout";

// Pages
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ProductsPage } from "./pages/ProductsPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { ContactPage } from "./pages/ContactPage";
import { OffertePage } from "./pages/OffertePage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { AdminProductsPage } from "./pages/AdminProductsPage";
import { AdminCategoriesPage } from "./pages/AdminCategoriesPage";
import { AdminMessagesPage } from "./pages/AdminMessagesPage";
import { AdminSettingsPage } from "./pages/AdminSettingsPage";
import AdminCertificatesPage from "./pages/AdminCertificatesPage";

// Public Layout
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <div className="App">
              <BrowserRouter>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                  <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
                  <Route path="/products" element={<PublicLayout><ProductsPage /></PublicLayout>} />
                  <Route path="/products/:productId" element={<PublicLayout><ProductDetailPage /></PublicLayout>} />
                  <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
                  <Route path="/offerte" element={<PublicLayout><OffertePage /></PublicLayout>} />
                  
                  {/* Admin Routes */}
                  <Route path="/beheer" element={<AdminLoginPage />} />
                  <Route path="/beheer/dashboard" element={<AdminLayout><AdminDashboardPage /></AdminLayout>} />
                  <Route path="/beheer/producten" element={<AdminLayout><AdminProductsPage /></AdminLayout>} />
                  <Route path="/beheer/categorieen" element={<AdminLayout><AdminCategoriesPage /></AdminLayout>} />
                  <Route path="/beheer/berichten" element={<AdminLayout><AdminMessagesPage /></AdminLayout>} />
                  <Route path="/beheer/instellingen" element={<AdminLayout><AdminSettingsPage /></AdminLayout>} />
                  <Route path="/beheer/certificaten" element={<AdminCertificatesPage />} />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-right" />
            </div>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
